import React, { useEffect, useState } from "react";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import {
  ButtonGroupPreview,
  ButtonPreview,
  DropdownPreview,
  ImagePreview,
  LabelPreview,
  RecordsetListPreview,
  TableFieldPlaceholderPreview
} from "../../../../components/BuilderComponents/Preview/ElementsPreview";
import EditTableview from "../../../../components/EditComponents/EditTableview";
import { convertMapToClassname } from "../../../../utils/classStyles";
import RenderNestedGridLayout from "./RenderNestedGridLayout";
import Input from "../../../../components/FormComponents/Input";
import pdfImage from "../../../../images/pdf_image.png";
import mailImage from "../../../../images/mail_thread.png";
import formImage from "../../../../images/formImage.png";
const FieldsRedering = ({
  itemId,
  item,
  layoutData,
  tableRef,
  nestedGridData,
  dragFromOutside,
  setDragFromOutside,
  deleteElement,
  copyElement,
  handleModalAction,
  layout,
  setLayout,
  device,
  tableID
}) => {
  const [isHovered, setIsHovered] = useState(false);

  if (!layoutData.current[item.i]) return;
  const elementType = layoutData.current[item.i].type;
  const fieldType = layoutData.current[item.i]?.field_type || "";

  const borderArray = ["tableview", "tabview", "section", "timeline", "spacer"];

  const returnFieldsToRender = (elementType) => {
    if (!elementType) return;
    const className = layoutData.current[item.i]?.className;

    switch (elementType) {
      case "field":
      case "variable":
      case "empty":
        const fieldType = layoutData.current[item.i]?.field_type;
        switch (fieldType) {
          case "recordset-list":
          case "recordset":
          case "grid":
            return <RecordsetListPreview config={layoutData.current[item.i]} />;
          default:
            return <TableFieldPlaceholderPreview config={layoutData.current[item.i]} />;
        }
      case "html":
      case "dynamic-html":
        return <div dangerouslySetInnerHTML={{ __html: layoutData.current[item.i].content }}></div>;
      case "image":
        return <ImagePreview config={layoutData.current[item.i]} />;
      case "label":
        return (
          <div>
            <InlineEditableLable
              config={layoutData.current[item.i] || {}}
              onChange={(data) => {
                layoutData.current[item.i] = data;
                setLayout([...layout]);
              }}
            />
          </div>
        );
      case "tableview":
        return (
          <EditTableview
            layoutData={layoutData}
            itemId={item.i}
            handleModalAction={handleModalAction}
            tableRef={tableRef}
          />
        );
      case "tabview":
      case "section":
        return (
          <RenderNestedGridLayout
            dragFromOutside={dragFromOutside}
            itemId={item.i}
            setDragFromOutside={setDragFromOutside}
            nestedGridData={nestedGridData}
            layoutData={layoutData}
            tableRef={tableRef}
            handleModalAction={handleModalAction}
            layout={layout}
            setLayout={setLayout}
            tableID={tableID}
            device={device}
          />
        );
      case "button":
        return <ButtonPreview config={layoutData.current[item.i]} />;
      case "separator":
        return <hr className={convertMapToClassname(className)} />;
      case "dropdown":
        return <DropdownPreview config={layoutData.current[item.i]} />;
      case "button-group":
        return <ButtonGroupPreview config={layoutData.current[item.i]} />;
      case "file_viewer":
        return <img style={{ height: "60px", width: "60px" }} src={pdfImage} alt="img" />;
      case "mail_thread":
        return <img style={{ height: "100%", width: "100%" }} src={mailImage} alt="img" />;
      case "form":
        return <img style={{ height: "100%", width: "100%" }} src={formImage} alt="img" />;
      case "custom-component":
        return <div>{layoutData.current[item.i].name + " (custom-component)"}</div>;

      default:
        return <div>{layoutData.current[item.i].display || layoutData.current[item.i].name}</div>;
    }
  };

  const excludeEditAndCopy = ["empty", "timeline"];

  const generateActionIcons = () => {
    const icons = [];

    const canEditAndCopy = !excludeEditAndCopy.includes(elementType);

    const canAssignOrChange =
      ["empty", "field", "variable"].includes(elementType) &&
      fieldType !== "recordset" &&
      fieldType !== "recordset-list" &&
      layoutData.current[itemId]?.field_type !== "recordset" &&
      layoutData.current[itemId]?.field_type !== "recordset-list";

    const isEmpty = elementType === "empty";

    const isRecordset = ["recordset-list", "recordset", "grid"].includes(fieldType);
    const getTitle = (action) => {
      if (elementType === "field") {
        return `${action} ${layoutData.current[item.i]?.field_type}`;
      } else {
        return `${action} ${elementType}`;
      }
    };
    if (canEditAndCopy) {
      icons.push({
        type: "edit",
        title: getTitle("Edit"),

        // onClick: () => editElement(elementType, item.i)
        onClick: () => {
          handleModalAction({ type: "edit", i: item.i });
        }
      });
      if (!isEmpty) {
        icons.push({
          type: "content_copy",
          title: getTitle("Copy"),

          onClick: () => copyElement(elementType, layoutData.current[item.i], item)
        });
      }
    }
    if (canAssignOrChange) {
      icons.push({
        type: isEmpty ? "add" : "change_circle",
        title: isEmpty ? "Add Field" : "Change Field",

        // onClick: () => setIsModalOpen(layoutData.current[item.i].i)
        onClick: () => {
          handleModalAction({
            type: isEmpty ? "add" : "change",
            i: item.i,
            modal_name: isEmpty ? "Add field" : "Change field"
          });
        }
      });
    }
    if (isEmpty) {
      icons.push({
        type: "content_copy",
        title: getTitle("Copy"),

        onClick: () => copyElement(elementType, layoutData.current[item.i], item)
      });
    }
    if (isRecordset) {
      icons.push({
        type: "list_alt",
        title: "Design Layout",

        onClick: () => handleModalAction({ type: "recordset_layout", i: item.i, modal_name: "Design Layout" })
        // onClick: () => addFieldInsideRecordsetList(layoutData.current[item.i].i)
      });
    }
    icons.push({
      type: "delete",
      title: getTitle("Delete"),
      onClick: () => deleteElement(item.i)
    });

    return icons;
  };

  const renderActionIconList = generateActionIcons().map((icon) => {
    return <ButtonActionIcon type={icon.type} title={icon.title} size="xsm" key={icon.type} onClick={icon.onClick} />;
  });

  return (
    <div
      style={borderArray.includes(elementType) ? { border: "1px dashed #dadce0" } : { border: "1px solid transparent" }}
      className={`detailsView_input_items`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`form-buttons`} style={{ display: isHovered ? "flex" : "none" }}>
        {renderActionIconList}
      </div>

      {returnFieldsToRender(elementType)}
    </div>
  );
};

export default FieldsRedering;

const InlineEditableLable = ({ config, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [labelValue, setLabelValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setIsEditing(false);
    }
  };
  const editLabel = (e) => {
    setLabelValue(e.target.value);
    onChange({ ...config, name: e.target.value });
  };

  useEffect(() => {
    setLabelValue(config.name || "");
  }, [config]);

  return (
    <>
      {isEditing ? (
        <Input
          autoFocus={true}
          onBlur={() => setIsEditing(false)}
          value={labelValue}
          onChange={editLabel}
          onKeyDown={handleKeyDown}
        />
      ) : (
        <LabelPreview config={{ ...config, name: labelValue }} labelOnClick={() => setIsEditing(true)} />
      )}
    </>
  );
};
